module.exports = __webpack_public_path__ + "img/results_pull_time_series.08956e82.png";